import { createAlova } from 'alova'

import adapterFetch from 'alova/fetch'

const TOKEN_KEY = 'access_token'

const getBaseURL = () => {
  // Em localhost (dev ou preview), usa proxy
  const isLocalhost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')

  return isLocalhost ? '/api' : 'https://core.nexxo.app.br'
}

export const api = createAlova({
  baseURL: getBaseURL(),
  requestAdapter: adapterFetch(),
  cacheFor: {
    expire: 60 * 1000, // 1 minute
  },
  beforeRequest(method) {
    const token = localStorage.getItem(TOKEN_KEY)
    if (token) {
      method.config.headers.Authorization = `Bearer ${token}`
    }

    const selectedAccount = localStorage.getItem('selected_account')
    if (selectedAccount) {
      try {
        const account = JSON.parse(selectedAccount)
        method.config.headers['Nx-Account-ID'] = account.id
      } catch {
        // Ignora se não conseguir fazer parse
      }
    }
  },
  responded: {
    onSuccess: (response) => response.json(),
    onError: async (error) => {
      const isLoginRequest = error.config?.url?.includes('/auth/token')

      if (error.response?.status === 401 && !isLoginRequest) {
        localStorage.removeItem(TOKEN_KEY)
        localStorage.removeItem('refresh_token')
        window.location.href = '/#/auth/login'
      }

      if (error.response) {
        try {
          error.response.data = await error.response.json()
        } catch {
          // Se não conseguir fazer parse do JSON, mantém o erro original
        }
      }

      throw error
    },
  },
})
